module.exports = __webpack_public_path__ + "media/images/social/youtube2-8524cb3eea6868a6b44302869ae38839.png";